<template>
  <FormModal class="form-modal--intro form-modal--secondary">
    <template #body>
      <div class="form-modal__logo-container">
        <InlineSvg
          class="form-modal__logo"
          src="images/logo.svg"
          :alt="concept"
        />
      </div>
      <div class="form-modal__title">
        Nous allons maintenant vous poser quelques questions. Cela nous permet
        de trouver les agences qui vous conviennent.
      </div>
    </template>

    <template #footer>
      <t-btn-link
        id="footerNextButton"
        class="footer__next-btn"
        to="/quotes-requests/type-de-demande"
      >
        Continuer
      </t-btn-link>
    </template>
  </FormModal>
</template>

<script>
import InlineSvg from 'vue-inline-svg'
import FormModal from 'chimera/all/themes/blueflow/components/layout/FormModal'
import AbstractFormPage from 'chimera/all/components/page/AbstractFormPage'

export default {
  components: {
    FormModal,
    InlineSvg,
  },

  extends: AbstractFormPage,

  layout: 'form',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Commencer le questionnaire',
      headDescription:
        'Nous allons maintenant vous poser quelques questions. Cela nous permet de trouver les agences qui vous conviennent.',
      path: '/quotes-requests/debut',
      progressValue: 0,
      checkoutStep: 1,
    }
  },
}
</script>
